import helpers from "@/helpers";

export default (instance) => {
  return {
    getRegions() {
      return instance
        .get("api/regions")
        .catch((error) => helpers.notify.createErrorNotify(error));
    },
  };
};
